/**
 * [ADAM AUDIO foundation] Mute gate for Adam's voice.
 *
 * Replaces `useAuctioneerTTS` + `useSnakeAdamTTS`, which were
 * near-identical per-route queues holding at most ONE pending line
 * (`if (queueRef.current.length >= 1) queueRef.current.shift()`) - a
 * third line silently destroyed the second. Queueing now lives in
 * `audio/auctioneerAudio.js`, which is the only layer that can serialize
 * the shared Audio element, so both formats share this single hook and
 * it has one job: keep the audio singleton's mute state in sync with the
 * room's toggle.
 */
import { useEffect } from "react";
import { setMuted } from "../audio/auctioneerAudio";

export function useAdamVoiceGate(muted) {
  useEffect(() => { setMuted(!!muted); }, [muted]);
}
